import {createTheme} from '@mantine/core';

export const breakpoints = {
  // Calculated assuming 1em = 16px
  xs: '30em', // 480px
  sm: '48em', // 768px
  md: '64em', // 1024px
  lg: '74em', // 1184px
  xl: '90em', // 1440px
};

/**
 * Semantic color tokens for quiz UI components.
 * Import and use these instead of hardcoding hex values in styled components.
 */
export const quizColors = {
  /** Focus ring / active selection border — Mantine blue */
  focusBorder: '#228BE6',
  /** Correct-answer border */
  correctBorder: '#7ED957',
  /** Correct-answer background fill */
  correctBackground: '#ebf2ed',
  /** Wrong-answer border */
  wrongBorder: '#E03131',
  /** Wrong-answer background fill */
  wrongBackground: '#FFF5F5',
} as const;

export const mantineTheme = createTheme({
  /** Override mantine theme */
  breakpoints,
});
